import { render, staticRenderFns } from "./EmailForm.vue?vue&type=template&id=6826bdfb&"
import script from "./EmailForm.vue?vue&type=script&lang=ts&setup=true&"
export * from "./EmailForm.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6826bdfb')) {
      api.createRecord('6826bdfb', component.options)
    } else {
      api.reload('6826bdfb', component.options)
    }
    module.hot.accept("./EmailForm.vue?vue&type=template&id=6826bdfb&", function () {
      api.rerender('6826bdfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentScreens/components/ClubPendingPayment/components/EmailForm.vue"
export default component.exports